import React from 'react';
import config from '../utility/config'
import '../css/SSOPage.css'

import { Button } from '@material-ui/core';

export default class SSOPage extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {

        // uncomment the next line for auto redirect to SSO   
        //window.location.href = config.SsoLink;
        
        return (
            <>
                <div className='SSOpage'>
                    <h1>Please Sign In to Continue...</h1>
                    {/* <Link href={config.SsoLink} target=""><img className="sso" src={sso}></img></Link> */}
                    <Button variant="contained" className="sso" href={config.SsoLink} target="">
                        LOGIN
                    </Button>
                </div>


            </>

        );
    }

}